import { EY_DELIVERS, EY_PRODUCTS, getEnvironment, SERVICE_LINE, COUNTRY, SUB_AREA, HIERARCHY_1 } from '../metrics/metricsConstants';

/**
 * Performs the tracking calls to Adobe Tag Manager.
 * @module adobeLaunch
 * @class
 * @internal
 */
class adobeLaunch {
  constructor(options = {}) {
    this.options = options;
    this.name = 'Adobe Launch';
  }
  /**
   *
   * @method pageView
   * @param {String} eventName
   * @param {Object} params
   * @returns {Promise}
   * @internal
   */
  pageView(...args) {
    return this.track(...args);
  }
  /**
   *
   * @method track
   * @param {String} eventName
   * @param {Object} params
   * @returns {Promise}
   * @internal
   */
  track(eventName, params) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(satellite => {
          this._satellite = this._satellite || satellite;

          this._track(eventName, params);
          resolve({
            eventName,
            params,
          });
        })
        .catch(error => {
          console.error('Omniture: Failed to load seed file', error);
          reject(error);
        });
    });
  }
  /**
   *
   * @method _track
   * @param {String} eventName
   * @param {Object} params
   * @protected
   */
  _track(eventName, params) {
    //this._satellite.data.customVars = {};
    this._satellite.setVar(eventName, params);
    this._satellite.track(eventName, params);
  }
  /**
   *
   * @method _load
   * @protected
   */
  _load() {
    return (
      this._promise ||
      (this._promise = new Promise((resolve, reject) => {
        if (window._satellite) {
          resolve(window._satellite);
        } else {
          const script = document.createElement('script');
          script.src = this.options.seedFile;
          script.async = true;
          document.head.appendChild(script);
          script.onload = () => {
            this._addPageBottom();
            resolve(window._satellite);
          };

          script.onerror = error => {
            reject(error);
          };
        }
      }))
    );
  }
  /**
   *
   * @method _addPageBottom
   * @protected
   */
  _addPageBottom() {
    const head = document.head;
    const script = document.createElement('script');
    // Lets add to page so Adobe consultant knows we've added the pageBottom() call.
    const scriptContent = `
      "use strict";

      var digitaldata = {
        page : {
            environment : "${getEnvironment(process.env.NODE_ENV)}",
            eYProduct : "${EY_PRODUCTS}",
            eYApplication : "${EY_DELIVERS}",
            serviceLine : "${SERVICE_LINE}",
            hierarchy1 : "${HIERARCHY_1}",   
            pageName : "",
            area : "${COUNTRY}",
            subArea : "${SUB_AREA}",
            country : "${COUNTRY}",  
            language : "en",
            searchVertical: ""
        },
        user : {
            userId : ""
        },
        engagement: {
          number: null,
          clientName: "",
          engagementName: ""
        },
        onclick: {
          event: "",
          contentUrl: ""
        },
        component: {
          link: {
            linkIdentifier: ""
          }
        }
      }
  `;

    script.text = scriptContent;
    return head.prepend(script);
  }
}

export default adobeLaunch;
